import React from 'react'
import { Form } from 'react-bootstrap'
import { useForm } from 'react-hook-form'
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap'
import { message } from 'antd'

import EmployeeTypeForm from './EmployeeTypeForm'

import { updateEmployeeType } from '../services'
import { handleError } from '../../../helpers'

export default function EditEmployeeTypeModal({ visible, onClose, employeeType, reload }) {
	const { handleSubmit, register, formState: { errors } } = useForm({
		defaultValues: {
			name: employeeType.name
		}
	})

	const onSubmit = values => {
		updateEmployeeType(employeeType.id, values)
			.then(res => {
				message.success(res.data.message)
				reload()
				onClose()
			})
			.catch(handleError)
	}

	return (
		<Modal isOpen={visible} toggle={onClose}>
			<ModalHeader toggle={onClose}>Actualizar Categoría</ModalHeader>
			<ModalBody>
				<Form onSubmit={handleSubmit(onSubmit)}>
					<EmployeeTypeForm 
						register={register}
						errors={errors}
						onlyEditable
					/>
					<Button color="primary" type="submit">
						Actualizar Categoría
					</Button>
				</Form>
			</ModalBody>
		</Modal>
	)
}